import React, { FC } from "react";
import { useIntl } from "react-intl";
import { OverlayTrigger, Tooltip } from "react-bootstrap-v5";
import { Link, useHistory } from "react-router-dom";
import _ from "lodash";
import moment from "moment";
import { PaymentDoc, PaymentRequestModel } from "../../models/PaymentRequestModel";
import { HeaderModel } from "../../models/CommonModel";
import SortableColumn from "../../components/Table/SortableColumn"; 
import { formatPrice } from "../../selectors";


type TProps = {
    data: Array<PaymentRequestModel>,
    header: HeaderModel[],
    hideCols: string[],
    openColConfig: () => void,
    handleSort: (sortBy: string, direction: 'asc' | 'desc' | 'none') => void
    viewRequest: (item: PaymentRequestModel) => void
}

const RequestTable: FC<TProps> = ({ data, header, hideCols, openColConfig, handleSort, viewRequest }) => {
    const intl = useIntl();

    const renderStatus = (status: string) => {
        switch (status) {
			case 'pending':
				return <span className={'text-warning'}>Đang chờ</span>;
			case 'paid':
				return <span className={'text-primary'}>Đã thanh toán</span>;
			case 'confirmed':
				return <span className={'text-success'}>Đã xác nhận</span>;
            case 'canceled':
                return <span className={'text-danger'}>Đã hủy</span>;
		}
    }

    const renderPaymentMethod = (payment_method: string) => {
        switch (payment_method) {
			case 'banking':
				return <span>Chuyển khoản</span>;
			case 'cash':
				return <span >Tiền mặt</span>;
		}
    }

    return <div className='table-responsive'>
        <table className="table table-hover table-bordered table-striped border gy-7 gs-7">
            <thead>
                <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                    <th>
                        <i
                            className="fa fa-cogs"
                            style={{ cursor: 'pointer' }}
                            onClick={openColConfig}
                        ></i>
                    </th>
                    {header.map((th, index) => {
                        if (!hideCols.includes(th.field)) {
                            if (th.sortable) {
                                return (
                                    <SortableColumn
                                        key={'th-' + index}
                                        sortBy={th?.field}
                                        onSortChange={handleSort}
                                        style={th?.style ?? {}}
                                    >
                                        {th.label}
                                    </SortableColumn>
                                )
                            }
                            return (
                                <th style={th?.style ?? {}}>{th.label}</th>
                            )
                        }
                    })}
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {data?.map((item: PaymentRequestModel, index: number) => {
                    return (
                        <tr key={`receipt_${item.id}_${index}`} className='cursor-pointer'>
                            <td>
                            </td>
                            {!hideCols.includes('code') && (
                                <td>{item.request_code}</td>
                            )}
                            {!hideCols.includes('store') && (
                                <td>{ item.store?.business_name ?? item.store?.name }</td>
                            )}
                            {!hideCols.includes('amount') && (
                                <td>{formatPrice(item.amount ?? 0)}</td>
                            )}
                            {!hideCols.includes('status') && (
                                <td>{renderStatus(item.status ?? '')}</td>
                            )}
                            {!hideCols.includes('payment_method') && (
                                <td>{renderPaymentMethod(item.payment_method ?? '')}</td>
                            )}
                            {!hideCols.includes('created_at') && (
                                <td>
                                    Tạo: {moment(item.created_at).format('DD-MM-YYYY H:m:s')}<br/>
                                    Cập nhật: {moment(item.updated_at).format('DD-MM-YYYY H:m:s')}
                                    {item.confirmed_at && (
                                        <>
                                            <br/>
                                            Xác nhận: {moment(item.confirmed_at).format('DD-MM-YYYY H:m:s')}
                                        </>
                                    )}
                                </td>
                            )}
                            {!hideCols.includes('payment_docs') && (
                                <td>
                                    {item?.payment_docs?.map((el: PaymentDoc) => {
                                        return (
                                            <p>
                                                <a 
                                                    href={el.file_path} 
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className='text-primary cursor-pointer mb-2'
                                                >{el.file_name}
                                                </a>
                                            </p>
                                        )
                                    })}
                                </td>
                            )}
                            <td>
                                <button onClick={() => viewRequest(item)} className="btn btn-icon btn-light-primary w-30px h-30px ps-2 me-2">
                                    <i className="bi bi-eye-fill fs-4 me-2"></i>
                                </button>
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    </div>
}
export default RequestTable
